import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import Trans from 'next-translate/Trans'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { blueLink } from '@app/components/stateless/typo/link-style'
import { ThemedImage } from '@app/components/general/themes/theme-image'
import { LazyMount } from '@app/components/lazy/lazymount'
import { companyName } from '@app/configs'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/vscode-extension',
    }),
  }
}

function VSCodeExtension() {
  const { t } = useTranslation('vscode-extension')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <div>
          <Header>{t('header')}</Header>
          <Paragraph className='text-lg'>{t('header-details')}</Paragraph>
        </div>
        <div>
          <Header2>{t('feats')}</Header2>
          <Paragraph>{t('feats-details')}</Paragraph>
        </div>
        <div className='py-6'>
          <div className='p-3 border rounded bg-gray-100 dark:bg-gray-800 dark:border-gray-700'>
            <Header3 className='text-center'>{t('editor')}</Header3>
            <LazyMount className='py-4 flex place-items-center place-content-center'>
              <ThemedImage
                src={'/img/vscode-light.png'}
                srcDark={'/img/vscode-dark.png'}
                alt={t('header')}
                width={1107 / 1.5}
                height={1220 / 1.5}
              />
            </LazyMount>
          </div>
        </div>
        <Trans
          i18nKey='vscode-extension:editor-details'
          values={{ companyName: companyName }}
          components={[
            <Paragraph key={'editor1'} />,
            <a
              href='https://github.com/a11ywatch/vscode-extension'
              className={blueLink}
              target={'_blank'}
              rel='noreferrer'
              key={'editor-1'}
            />,
          ]}
        />
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { VSCodeExtension },
  {
    translation: 'vscode-extension',
  }
)
